import React, { useCallback, useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';
import MathContent from '../../../math-content';
import { Container, Value } from '..';

export const ListedContainer = styled(Container)`
    text-align: center;

    ${(props) =>
        !props.disabled &&
        css`
            &:hover {
                border: 1px solid var(--blue700);
                background-color: var(--gray50);
            }

            &:focus {
                box-shadow: 0px 0px 2px 2px var(--blue200);
                box-shadow: var(--outline);
            }

            &:active {
                box-shadow: var(--shadow-4);
                border: 1px solid var(--blue400);
                outline: none;
            }
        `};
`;

const ChoiceChipListed = ({ disabled = false, id, handleClick, value, scrollingFn }) => {
    const ref = useRef(null);
    const [mathRendered, setMathRendered] = useState(false);
    const onClick = () => {
        if (!disabled && handleClick) {
            handleClick();
        }
    };

    useEffect(() => {
        scrollingFn && scrollingFn(ref, mathRendered);
        return () => {};
    }, [scrollingFn, mathRendered]);
    const onRendered = useCallback(() => setMathRendered(true), []);

    return (
        <ListedContainer aria-pressed="false" disabled={disabled} id={id} role="button" tabIndex="0" onClick={onClick}>
            <Value ref={ref} onScroll={() => scrollingFn(ref)}>
                <MathContent onRendered={onRendered} inTabOrder={false}>
                    {value}
                </MathContent>
            </Value>
        </ListedContainer>
    );
};

ChoiceChipListed.propTypes = {
    disabled: PropTypes.bool,
    id: PropTypes.string,
    handleClick: PropTypes.func,
    value: PropTypes.string,
    scrollingFn: PropTypes.func,
};

export default ChoiceChipListed;
